import React from "react";
import { Redirect } from "react-router";

const RedirectAdmin = () => <Redirect to="/playlists" replace />;

export default RedirectAdmin;



// WEBPACK FOOTER //
// ./src/router/RedirectAdmin.jsx